// Copyright (c) 2016 Deere & Company

import CreditMemoReport from '../../../reports/credit-memo/state-connector';

export default {
    component: CreditMemoReport,
    name: 'CREDIT_MEMO',
    path: 'credit-memo'
};



// WEBPACK FOOTER //
// ./src/routes/claims/reports/credit-memo.js